/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Toggle/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Toggle({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditRules/MaxDiscount/Value/Toggle"
  
}) {
let typeTextValueData = fromData.useDataValue({ viewPath,
context: 'type',
path: 'text',
})
let typeIdValueData = fromData.useDataValue({ viewPath,
context: 'type',
path: 'id',
})
let rulesetMaxDiscountTypeValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'max_discount.type',
})
let aggregateData = fromAggregate.equals(typeIdValueData, rulesetMaxDiscountTypeValueData)
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="type.text"
 text={typeTextValueData}
 onClick={onClick}
 data="type.id"
 data="ruleset.max_discount.type"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}